import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { useMutation } from '@tanstack/react-query';
import { JobsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useState } from 'react';
import { EntityIconProfile } from '@components/core-ui/EntityIcon/variations/EntityIconProfile';
import { AvatarBlock } from './styles/AvatarBlock';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  workspaceId: string;
  jobId: string;
  onSuccess?: () => void;
};

export const CommentForm = ({ workspaceId, jobId, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { me } = useAuthContext();
  const [comment, setComment] = useState('');

  const commentMutation = useMutation({
    mutationFn: (text: string) =>
      call(() => JobsService.commentJob({ wsid: workspaceId, jobId, requestBody: { comment: text } })),
    onSuccess: () => {
      setComment('');
      onSuccess?.();
    },
    onError: notifyApiCallError,
  });

  const submit = (e: { preventDefault: () => void }) => {
    if (e) {
      e.preventDefault();
    }
    if (commentMutation.isPending) {
      return;
    }
    commentMutation.mutate(comment);
  };

  const renderAvatar = () => {
    if (!me) {
      return '';
    }
    return (
      <AvatarBlock>
        <EntityIconProfile name={`${me.name} ${me.lastname}`} src={me.avatar ?? undefined} />
      </AvatarBlock>
    );
  };

  return (
    <Wrapper>
      <form onSubmit={submit}>
        <div className="form-line">
          {renderAvatar()}
          <Textarea
            className="comment-field w-full min-w-0 flex-1"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            label="Write your comment here"
            name="comment"
          />
        </div>
        <Button onClick={submit} disabled={!comment.length || commentMutation.isPending}>
          Comment
        </Button>
      </form>
    </Wrapper>
  );
};
